import styled from '@emotion/styled';

export const InvitationButtonsContainer = styled.div(({ theme }) => ({
  display: 'grid',
  gap: '0.5rem',
  gridTemplateColumns: 'auto',
  [theme.breakpoints.up('sm')]: {
    //max-content keeps each button's text on one line; the auto column takes the rest.
    gridTemplateColumns: 'max-content auto max-content max-content max-content',
  },
}));
